import { Link } from '@kl/components-v6';
import styled from 'styled-components';

export const StyledLink = styled(Link)`
    display: block;
    height: 32px;
`;

export const StyledLogo = styled.svg.attrs({
    height: '23',
    viewBox: '0 0 120 23',
    width: '120',
    xmlns: 'http://www.w3.org/2000/svg',
})`
    height: 32px;
    width: 140px;
`;
